import { Box } from "@mui/material";
import IconButton from "../../components/buttons/IconButton";
import { ReactComponent as PDFIconSVG } from "../../scenes/stack/environment/icons/Export_PDF_currentColor.svg";

export default function IconButtonDemo() {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {["outlined", "standard"].map((type) => (
        <Box key={type} display="flex" flexDirection="column" gap={2}>
          {["XS", "S", "M", "L"].map((size) => (
            <Box key={`${type}-${size}`} display="flex" gap={3}>
              <IconButton
                onClick={() => {}}
                IconSVG={PDFIconSVG}
                size={size}
                buttonStyle={type}
                color="inherit"
              />
              <IconButton
                onClick={() => {}}
                IconSVG={PDFIconSVG}
                size={size}
                buttonStyle={type}
                color="inherit"
                disabled={true}
              />
              <IconButton
                onClick={() => {}}
                IconSVG={PDFIconSVG}
                size={size}
                buttonStyle={type}
                color="inherit"
                loading={true}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
